import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconSpeaker = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    ref={ref}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="yfm-icon yfm-icon-speaker"
    {...omit(props, ["className"])}
  >
    <path
      d="M6.94264 0.750776L3.61452 3.82171H1.53967C0.957641 3.82171 0.617798 4.38562 0.617798 4.96109V9.06249C0.617798 9.63765 0.957798 9.9739 1.53967 9.9739H3.61452L6.94264 13.25C7.52467 13.25 7.99452 12.8281 7.99452 12.2523V1.77109C7.99452 1.19578 7.52467 0.750776 6.94264 0.750776ZM11.6811 6.99906C11.6811 7.25109 11.7645 7.45609 11.8697 7.45609H13.1875C13.2912 7.45609 13.2969 7.26374 13.2969 7.01156V6.55593H11.9136C11.81 6.55593 11.6811 6.74687 11.6811 6.99906ZM12.1895 2.20312L13.3301 1.55234C13.4208 1.50124 13.389 1.28203 13.2623 1.06406C13.1356 0.846089 12.9583 0.709526 12.8676 0.760776L11.727 1.41156C11.6362 1.46281 11.668 1.68218 11.7947 1.89999C11.9214 2.11781 12.0987 2.25453 12.1895 2.20312ZM13.3301 12.4469L12.1895 11.7961C12.0987 11.745 11.923 11.8816 11.7947 12.0994C11.6664 12.3172 11.6362 12.5369 11.727 12.588L12.8676 13.2386C12.9583 13.2898 13.134 13.1531 13.2623 12.9353C13.3906 12.7175 13.4219 12.4983 13.3306 12.4469H13.3301ZM9.39061 4.49296C9.16436 4.34765 8.91092 4.44156 8.76561 4.66484C8.6203 4.88812 8.71233 5.13906 8.94014 5.28281C9.63311 5.5975 10.0348 6.35921 9.9442 7.18906C9.86608 7.90093 9.56092 8.46765 8.9228 8.75968C8.67077 8.85218 8.64467 9.08859 8.73827 9.33906C8.8378 9.56265 9.11717 9.63812 9.32608 9.5214C10.2178 9.13687 10.8014 8.24015 10.9042 7.29156C11.0342 6.10765 10.4175 5.08249 9.39061 4.49296Z"
      fill="url(#paint0_linear_540_293)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_540_293"
        x1="0.617798"
        y1="7"
        x2="13.383"
        y2="7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF8400" />
        <stop offset="0.5" stopColor="#FB5A90" />
      </linearGradient>
    </defs>
  </svg>
));

IconSpeaker.displayName = "IconSpeaker";

export default IconSpeaker;
